import { makeStyles, TableCell, TableCellProps } from '@material-ui/core';
import React from 'react';

export type TableKeyCellProps = TableCellProps & {
}

export function TableKeyCell ({className, ...props}: TableKeyCellProps) {
    const cls = useStyles();

    return (
        <TableCell {...props} className={`${className} ${cls.root}`} />
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        fontWeight: 'bold'
    }
}));
